import styled from 'styled-components'
import Dropzone from 'react-dropzone'
import { v1 as color } from 'sidecar-design-library'

export default styled(Dropzone)`
  height: 20.3125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: ${color.MORTAR};
  cursor: pointer;
  transition: background 0.2s;
  border-radius: 0.625rem;

  ${p => p.disabled && 'filter: grayscale(1);'}

  img {
    width: 10rem;
    height: 12.5rem;
    margin-bottom: 1.25rem;
  }

  &:hover {
    background: ${color.AQUA_OVERLAY};
    border: inset 2px ${color.AQUAMARINE};
    border-style: dashed;
  }
`
